import React, {useState} from 'react';

import cs from 'classnames';
import {Link} from 'react-router';

import {StyledCompactItemHeaderSpan} from 'app/general/bootstrap/utils';
import {DeleteDocumentModal} from 'app/general/modals/DeleteDocumentModal';
import {ActionsButton} from 'app/general/widgets/ActionsButton';
import {StyledDocItem} from 'app/procedures/styles';
import {getContentType} from 'app/utils/content-type';
import {getTemplateName} from 'app/utils/fallbacks';
import {gt} from 'app/utils/i18n';

import {TransferTemplateModal} from './TransferTemplateModal';

import type {TemplateSerializedType} from 'sweet-types';

interface Props {
  template: TemplateSerializedType;
  isSuperManager: boolean;
}

export function CompactTemplateListItem({template, isSuperManager}: Props) {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showTransferTemplateModal, showTransferModal] =
    useState<boolean>(false);

  const documentCt = getContentType(template.document_content_type);

  return (
    <StyledDocItem className="row border-top py-2 d-flex align-items-center position-relative">
      <div className="col d-flex align-items-center">
        <Link
          className="text-dark font-weight-bold d-block d-sm-inline"
          to={template.html_url}
        >
          <StyledCompactItemHeaderSpan>
            <i className={cs(documentCt.icon, 'mr-1')} />
            {getTemplateName(template)}
          </StyledCompactItemHeaderSpan>
        </Link>
      </div>
      <div className="col-auto order-lg-5">
        <ActionsButton
          actions={[
            {
              key: 'transfer',
              icon: 'far fa-file-export',
              text: gt('Use'),
              callback: () => showTransferModal(true),
            },
            {
              key: 'delete',
              icon: 'far fa-trash',
              text: gt('Delete'),
              callback: () => setShowDeleteModal(true),
              condition: () => isSuperManager,
            },
          ]}
        />
      </div>

      {showDeleteModal && (
        <DeleteDocumentModal
          show={showDeleteModal}
          object={template}
          redirectContentType="template"
          onClose={() => setShowDeleteModal(false)}
        />
      )}

      {showTransferTemplateModal && (
        <TransferTemplateModal
          templateName={getTemplateName(template)}
          templateURL={template.url}
          isOpen={showTransferTemplateModal}
          icon={documentCt.icon}
          onClose={() => showTransferModal(false)}
        />
      )}
    </StyledDocItem>
  );
}
